"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * 事件监听相关兼容处理
 */
var Event = {
  /**
   * 添加绑定事件
   * @param {*} ele 元素
   * @param {string} event 事件类型
   * @param {Function} handler 事件处理函数
   * @param {boolean} useCapture 捕获阶段/冒泡阶段
   */
  addEvent: function addEvent(ele, event, handler) {
    var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    // 默认是冒泡阶段
    if (ele.addEventListener) {
      ele.addEventListener(event, handler, useCapture);
    } else if (ele.attachEvent) {
      ele.attachEvent('on' + event, handler);
    } else {
      ele['on' + event] = handler;
    }
  },

  /**
   * 移除绑定事件
   * @param {*} ele 元素
   * @param {string} event 事件类型
   * @param {Function} handler 事件处理函数
   */
  removeEvent: function removeEvent(ele, event, handler) {
    if (ele.addEventListener) {
      ele.removeEventListener(event, handler, false);
    } else if (ele.attachEvent) {
      ele.detachEvent('on' + event, function () {
        handler.call(ele);
      });
    } else {
      ele['on' + event] = null;
    }
  },

  /**
   * 获取事件对象
   * @param {Object} e 事件对象
   */
  getEvent: function getEvent(e) {
    return e || window.event;
  },

  /**
   * 获取事件源
   * @param {Object} e 事件对象
   */
  getTarget: function getTarget(e) {
    return e.target || e.srcElement;
  },

  /**
   * 阻止冒泡行为
   * @param {Object} e 事件对象
   */
  stopPropagation: function stopPropagation(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      e.cancelBubble = true;
    }
  },

  /**
   * 阻止默认行为
   * @param {Object} e 事件对象
   */
  preventDefault: function preventDefault(e) {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      ele.returnValue = false;
    }
  }
};
var _default = Event;
exports["default"] = _default;